import {Component, OnInit} from '@angular/core';
import {SecurityService} from '../../security.service';
import {DataStorageService} from '../../data-storage.service';
import {ApiTextService} from '../../apiServices/text/text.service';
import {HttpClient, HttpErrorResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfigService} from '../../config.service';
import {PricingService} from '../../pricing.service';
import {ApiService} from '../../api.service';

@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.scss']
})
export class DisclaimerComponent implements OnInit {

  // @ts-ignore
  constructor(
    public dataStorageService: DataStorageService,
    private http: HttpClient,
    private route: ActivatedRoute,
    //  public securityService: SecurityService,
    private tApi: ApiTextService,
    public router: Router,
    public securityService: SecurityService,
    private configService: ConfigService,
    private pricing: PricingService,
    private api: ApiService,
  ) {
    this.dataStorageService.disclaimeerOn = false;

  }

  ngOnInit() {
    this.getToken(localStorage.getItem('user').toString(), localStorage.getItem('partnerId').toString());
  }

  getToken(code, partnerId) {
    //console.log('ok11', code, partnerId);
    this.dataStorageService.invalidCredentials = '';
    this.securityService.getTokenWithCode(code, partnerId)
      .then(() => {
        this.tApi.getAllUITexts().then(res => this.dataStorageService.uiText = res);
        this.api.getCategories();
        this.api.getGlobalCategories();
        this.pricing.getPPHostedNodesPricelist().then(res => this.dataStorageService.nodesPricingPPhosted = res);
        if (this.securityService.isAdmin() && (!this.securityService.isUser() || !this.securityService.isLeader())) {
          this.router.navigate(['/management']);
        } else if (this.securityService.isUser() || this.securityService.isLeader()) {
          //  this.router.navigate(['/disclaimer']);
          // setTimeout(() => this.router.navigate(['/disclaimer']), 500);
          console.log('ok');
        }
      }).catch(error => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        this.dataStorageService.invalidCredentials = 'Invalid Credentials';
      }
      alert('403 Forbidden oauth connect');
      window.location.href = 'https://portal.peoplefone.ch';

      // this.securityService.logout();
    });
  }

  onNextClick() {
    this.dataStorageService.disclaimeerOn = true;
  }

  updateText(event, key: string) {
    const value = event.target.value;
    this.tApi.putUIText(key, value);
    this.dataStorageService.setUIText(key, value);
  }

  getDesc() {
    return this.dataStorageService.filterUIText('offer.options.disclaimer.desc');
  }
}



// WEBPACK FOOTER //
// ./src/app/content/disclaimer/disclaimer.component.ts